import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { forwardRef, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// eslint-disable-next-line react/display-name
export const Content = forwardRef(
  ({ blog: { tags, title, description,blogImages,index} }, ref) => {
    const [skeleton, setSkeleton] = useState(true);


  const image = blogImages[0].url
  const alt = blogImages[0].description

    const handleImageLoad = () => {
      setSkeleton(false);
    };

    useEffect(() => {}, [skeleton]);

    return (
      <>
        <Head>
          <link rel="preload" href={image} as="image" />
        </Head>
        <article
          ref={ref}
          className="max-w-2xl mt-5 mx-auto antialiased pt-4 px-4 md:px-0 "
        >
          <div className="mb-10">
            <div className="flex gap-2">
              {tags.map((e, i) => (
                <h2
                  key={i}
                  className="bg-[#ec1c1cc7] capitalize text-white rounded-full text-xs w-fit px-4 py-1 mb-4"
                >
                  {e}
                </h2>
              ))}
            </div>
            <h1
              className={" text-2xl md:text-3xl mb-4 font-bold text-balance "}
            >
              {title}
            </h1>
            <div className="text-sm text-neutral-700 prose prose-sm">
              <div className="relative ">
                {skeleton && (
                  <div className="absolute top-0 left-0 w-full h-full">
                    <Skeleton className=" h-full rounded-lg " />{" "}
                    {/* Show the skeleton while the image is loading */}
                  </div>
                )}
                <Image
                  src={image}
                  alt={alt}
                  height={500}
                  width={500}
                  quality={75}
                  priority
                  // placeholder="blur"
                  // loading="lazy"
                  onLoad={handleImageLoad} // Trigger state change when the image is loaded
                  className={`rounded-lg w-full h-auto mb-5 object-cover transition-opacity duration-500 ${
                    skeleton ? "opacity-0" : "opacity-100"
                  }`} // Use opacity to fade in the image once loaded
                />
              </div>
              <div className=" bg-black/10 my-3  rounded-lg p-5 ">
                <h2 className=" text-black font-bold text-2xl ">
                  In This Post
                </h2>
                <ol className=" mt-3 list-disc ml-5 flex flex-col gap-2 ">
                  {index.map((e, i) => (
                    <li key={i} >
                      <Link title={e.label}  href={"#" + e.url} className=" underline ">{e.label}</Link>
                    </li>
                  ))}
                </ol>
              </div>
              <div
                className=" text-black flex flex-col gap-5  text-wrap "
                dangerouslySetInnerHTML={{ __html: description }}
              ></div>
            </div>
          </div>
        </article>
      </>
    );
  }
);
